<template>
  <div class="c-journey-con c-journey-con-aaaaa">
    <div class="flex-scroll">
      <!-- 下拉加载刷新 -->
      <div v-if="recordeList.length > 0" class="reference">
        <p class="load-more" v-if="isLoading === 'prev'">
          <i class="el-icon-loading"></i>
        </p>
        <p v-else-if="hasMorePrev" class="load-next-btn" @click="loadMore('prev')">
          <i class="iconfont iconshuaxin"></i>
          <span>刷新浏览记录</span>
        </p>
        <p class="load-more load-end-label" v-else>已经是最新内容了</p>
      </div>

      <div class="follow-items" v-for="(record, index) in recordeList" :key="index + '_record'">
        <p class="show-time" :datetime="record.date">{{record.date}}</p>
        <template v-for="(item, i) in record.list">
          <div class="time-line-item" :key="i + index + '_item'">
            <p class="tl-line"></p>
            <span class="tl-time">{{getTimelineTime(item.visit_time)}}</span>
            <i class="iconfont tl-image" :class="iconList[item.type]"></i>
            <div class="tl-content">
              <h1 class="tl-username" v-html="replaceContent(item)"></h1>
              <table class="preview-table" v-if="item.type == 1">
                <thead>
                  <tr class="tr thead">
                    <th>价格</th>
                    <th v-if="item.house_type_name">物业类型</th>
                    <th v-if="item.room_type_arr">户型</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class="tr">
                    <td>{{item.price || ''}}</td>
                    <td v-if="item.house_type_name">{{item.house_type_name}}</td>
                    <td v-if="item.room_type_arr" v-html="generateType(item.room_type_arr)"></td>
                  </tr>
                </tbody>
              </table>
              <div class="label-list" v-if="item.type == 5 && item.label.length > 0">
                  <span  v-for="(el,n) in item.label.indexOf('||')>-1 ? item.label.split('||') : [item.label]"  :key="n" :title="el">{{ el }}</span>
                </div>
              <div class="pre-origin">
                <span class="label">来源渠道：{{item.channel || ''}}</span>
                <span class="label" v-if="item.duration > 0">浏览时长：{{timeConvertUtil(item.duration / 1000 || 0, true) || 0}}</span>
              </div>
            </div>
          </div>
        </template>
      </div>
      <!-- 上拉加载更多 -->
      <template v-if="recordeList.length > 0">
        <p class="load-more" v-if="isLoading === 'next'">
          <i class="el-icon-loading"></i>
        </p>
        <p v-else-if="hasMoreEnd" class="load-more" @click="loadMore('next')">查看更多浏览记录></p>
        <p class="load-more load-end-label" v-else>浏览记录到这里咯</p>
      </template>
    </div>
  </div>
</template>
<script>
import {customeLogPlatformTrack} from '@/api/custome';
import { timeConvertUtil } from '@/utils/index';
export default{
  name: 'PreviewRecordList',
  props: {
    customeId: [String, Number],
    hasRecordTrack:Boolean,
    activeName: String,
    baseInfo: Object
  },
  data () {
    return {
      timeConvertUtil,
      iconList: {
        4: 'iconliebiao1',
        2: 'iconfabuwenzhang',
        1: 'iconloupanshuju',
        99: 'iconliebiao1',
        5:'iconloupanshuju'
      },
      recordeList: [],
      isLoading: '',
      hasMorePrev: true,
      hasMoreEnd: true,
      firstLoadData: null, // 初始化加载所有数据时候判断当前是否有浏览数据
    }
  },
  created() {
    // if(this.hasRecordTrack){
    //   this.initial();
    // }
  },
  methods: {
    initial () {
      const params = {
        platform_source_type: '',
        customer_id: this.customeId,
        customer_type: 1,
        time: Math.round(new Date().getTime() / 1000),
        time_type: 1,
        is_init: 0,
        per_page: 100
      }
      this.initList(params)
    },
    refrensh () {
      this.firstLoadData = null;
      this.recordeList = [];
      this.initial();
    },
    async initList (data, type) {
      if(!type && this.firstLoadData) return null
      try {
        const res = await customeLogPlatformTrack({
          ...data,
          customer_id: this.customeId,
          customer_type: 1,
          per_page: 100
        });
        const list = res || [];
        // 无轨迹数据则隐藏当前tab
        if (this.firstLoadData == null) this.firstLoadData = list;
        if (this.firstLoadData.length <= 0) {
          this.$emit('hideTrackTab');
          return null;
        }
        // 显示浏览记录tab
        this.$emit('showTrackTab');
        this.isLoading = '';
        this[type == 'prev' ? 'hasMorePrev' : 'hasMoreEnd'] = list.length > 0;
        if (this.recordeList.length == 0) {
          this.recordeList = list;
        } else if (list.length > 0){
          const records = this.recordeList.map(v => {
            const index = list.findIndex(a => a.date == v.date);
            if (index >= 0) {
              v.list = type === 'prev' ? [...list[index].list, ...v.list] : [...v.list, ...list[index].list];
              list.splice(index, 1);
            }
            return v;
          })
          this.recordeList = type == 'prev' ? [...list, ...this.recordeList] : this.recordeList.concat(list);
        }
        // 获取到当前是否需要定位
        const fixedData = list.find(v => v.checked == 1);
        this.$nextTick(_ => {
          if (!fixedData) return null;
          const item = $(`[datetime='${fixedData.date}']`);
          $('.c-journey-con-aaaaa').scrollTop(item.offset().top - 200);
        })
      } catch (err) {
        this.$message.error(err.msg || '操作失败，请重试');
      }
    },
    reload (data) {
      const params = {
        platform_source_type: data.platform_source_type,
        time: data.visit_time,
        time_type: 2,
        is_init: 1
      };
      this.firstLoadData = null;
      this.recordeList = [];
      this.isLoading= '';
      this.hasMorePrev= true;
      this.hasMoreEnd= true;
      this.initList(params);
    },
    loadMore (type) {
      this.isLoading = type;
      if (type === 'next') {
        const data = this.recordeList[this.recordeList.length - 1];
        const list = data.list || [];
        const last = list[list.length - 1];
        if (last && last.visit_time) {
          this.initList({
            time: last.visit_time_start,
            time_type: 1,
            is_init: 0
          }, 'next')
        }
      } else if (type === 'prev') {
        const data = this.recordeList[0]?.list?.[0];
        if (data && data.visit_time) {
          this.initList({
            time: data.visit_time_end,
            time_type: 2,
            is_init: 0
          }, 'prev')
        }
      }
    },
    fixNum (a) {
      return a < 10 ? `0${a}` : a;
    },
    getTimelineTime (time, isFullTime) {
      if (time) {
        const before = isFullTime ? new Date(time) : new Date(time * 1000);
        const now = Date.now();
        const diff = (now - before.getTime()) / 1000;
        if (diff < 3600) return Math.ceil(diff / 60) + '分钟前';
        else return `${this.fixNum(before.getHours())}:${this.fixNum(before.getMinutes())}:${this.fixNum(before.getSeconds())}`;
      } else {
        return '';
      }
    },
    replaceContent (data) {
      if (!data.url_replace || data.url_replace.length <= 0) return data.content;
      let content = data.content;
      let newContent = '';
      data.url_replace.map(v => {
        content.replace(v.text, function(word, index){
          const conLeft = content.substr(0, index);
          content = content.substr(index + word.length);
          newContent += `${conLeft}<a class="pre-relative" href="${v.url}" target="_blank">${word}</a>`;
        });
      })
      return newContent + content;
    },
    generateType (list) {
      return list.map(v => {
        return `<a class="pre-relative" style="font-size: 12px;margin-right:3px;" target="_blank" href="${v.url}">${v.name}</a>${v.price === '价格待定' ? '' : '价格为' + v.price}`;
      }).join('<br />')
    }
  },
}
</script>
<style lang="less" scoped>
.c-journey-con{
  .preview-table{
    width: 590px;
    margin-top: 3px;
    border-collapse: collapse;
    border: none;
    .tr{
      height: 40px;
      line-height: 40px;
      text-align: center;
    }
    .thead{
      background: #EEF5FF;
      th{
        font-weight: bold;
      }
    }
    td, th{
      color: #333;
      font-size: 12px;
      font-weight: normal;
      border: 1px solid #E8E8E8;
      line-height: 25px;
      padding: 7px 0;
    }
  }
  .label-list{
    margin:10px 0;
    span{
      display: inline-block;
      height:28px;
      line-height: 28px;
      padding:0 15px;
      margin-right:10px;
      border-radius: 12px;
      color:#333;
      background-color: #EFEFEF;
    }
  }
  .pre-origin{
    padding-top: 14px;
    font-size: 14px;
    color: #999999;
    display: -webkit-box;
  }
  .label{
    display: block;
    -webkit-box-flex: 1;
  }
  .load-next-btn{
    width: 130px;
    height: 30px;
    background: #EEF5FF;
    border: 1px solid #BDCFFF;
    border-radius: 3px;
    line-height: 28px;
    text-align: center;
    color: #3F80FE;
    font-size: 14px;
    cursor: pointer;
    .iconfont{
      display: inline-block;
      margin-right: 3px;
    }
  }

}
.tl-image{
  width: 23px;
  height: 23px;
  background: #3f80fe;
  color: #fff;
  font-weight: normal;
  border-radius: 50%;
  text-align: center;
  line-height: 23px;
  font-size: 11px;
}
.iconliebiao1{
  background: #3f80fe;
}
.iconfabuwenzhang{
  background: #0fb37b;
}
.cus-detail-popover-style .reference .load-more{
  text-align: center;
  margin-top: 0;
  display: block;
  left: 0;
  right: 0;
  margin: auto;
  width: 120px;
  padding: 0;
}
</style>
<style>
.pre-relative{
  color: #3F80FE;
  font-size: 14px;
  text-decoration: none;
}
</style>
